/** Canonical (AWS-style) Secret Manager id of a GitLab group's admin token.
 * Other providers rewrite it with their `replacer`. */
export const gitlabAiAdminTokenSecretId = (groupId: string): string =>
  `p0/install/gitlab/${groupId}/admin-token`;

/** Canonical prefix that every token secret of a GitLab group starts with.
 * Other providers rewrite it with their `replacer`. */
export const gitlabAiAccessTokenPrefix = (groupId: string): string =>
  `p0/access-token/gitlab/${groupId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const gitlabAiConnectorName = "p0-connector-gitlab-ai";
